import { Select } from 'antd';
import React from 'react';
import { EnumVariableModel } from '../../iasConfigSchema';
import VariableFormItem from '../variables/VariableFormItem';

const EnumWidget: React.FC<{
  variable: EnumVariableModel;
  disabled: boolean;
}> = ({ variable, disabled }) => {
  return (
    <VariableFormItem variable={variable}>
      <Select disabled={disabled}>
        {variable.options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.display_name}
          </Select.Option>
        ))}
      </Select>
    </VariableFormItem>
  );
};

export default EnumWidget;
